import Vue from "vue";
import VueRouter from "vue-router";
import routeList from "./route-list";
Vue.use(VueRouter);

const router = new VueRouter({
  routes: routeList
});

router.beforeEach((to, form, next) => {
  document.title = to.meta.title;
  next();
});

export default router;